module.exports = __webpack_public_path__ + "img/b2.c7a4368.png";